import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=36bb5d2d&lang=css"
import "./header.vue?vue&type=style&index=1&id=36bb5d2d&lang=scss&scoped=true"
import "./header.vue?vue&type=style&index=2&id=36bb5d2d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36bb5d2d"]])

export default __exports__